(() => {
  if (window.jpMapsyEnterSearch || location.pathname !== '/pages/store-locator') return;
  window.jpMapsyEnterSearch = true;
  const endpoint = '/apps/mapsy-store-locator/api/places/autocomplete';
  const nativeFetch = window.fetch;
  const pending = new Set();
  let sequence = 0;
  let delivered = null;
  let intent = null;

  function cancel() {
    if (intent) clearTimeout(intent.timeout);
    intent = null;
  }

  function current(input) {
    const root = input.closest('.mapsy-container');
    if (!root || !delivered || pending.size || delivered.sequence !== sequence ||
        delivered.query !== input.value.trim() || !delivered.predictions) return null;
    const options = [...root.querySelectorAll('.mapsy-search-suggestion')];
    if (input.getAttribute('aria-expanded') !== 'true' || !options.length ||
        options.length !== delivered.predictions.length ||
        options.some((option, index) => option.textContent.trim() !== delivered.predictions[index].name ||
          option.getAttribute('aria-busy') === 'true')) return null;
    return options;
  }

  function complete() {
    if (!intent) return;
    const { input, query } = intent;
    if (!input.isConnected || document.activeElement !== input || input.value.trim() !== query) {
      cancel();
      return;
    }
    const options = current(input);
    if (!options) return;
    const selected = options.find(option => option.classList.contains('selected')) || options[0];
    cancel();
    selected.click();
  }

  window.fetch = function (...args) {
    let query;
    try {
      const url = new URL(typeof args[0] === 'string' ? args[0] : args[0].url, location.href);
      if (url.origin === location.origin && url.pathname === endpoint &&
          args[1]?.method?.toUpperCase() === 'POST' && typeof args[1].body === 'string') {
        query = JSON.parse(args[1].body).input;
      }
    } catch (_) {}
    if (typeof query !== 'string') return nativeFetch.apply(this, args);
    const requestSequence = ++sequence;
    pending.add(requestSequence);
    return nativeFetch.apply(this, args).then(response => {
      if (!response.ok) {
        pending.delete(requestSequence);
        return response;
      }
      const json = response.json;
      response.json = function (...jsonArgs) {
        return json.apply(this, jsonArgs).then(data => {
          pending.delete(requestSequence);
          delivered = {
            query,
            sequence: requestSequence,
            predictions: Array.isArray(data.predictions) ? data.predictions : null
          };
          setTimeout(complete, 0);
          return data;
        }, error => {
          pending.delete(requestSequence);
          throw error;
        });
      };
      return response;
    }, error => {
      pending.delete(requestSequence);
      throw error;
    });
  };

  document.addEventListener('keydown', event => {
    const input = event.target;
    if (!input.matches?.('.mapsy-container #mapsy-search-input')) return;
    if (['Escape', 'ArrowDown', 'ArrowUp', 'Tab'].includes(event.key)) cancel();
    if (event.key !== 'Enter' || event.isComposing || event.keyCode === 229 ||
        event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
    const query = input.value.trim();
    if (query.length < 2) return;
    const options = current(input);
    if (options?.some(option => option.classList.contains('selected'))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (event.repeat || intent) return;
    intent = { input, query, timeout: setTimeout(cancel, 10000) };
    complete();
  }, true);

  document.addEventListener('input', event => {
    if (event.target.matches?.('.mapsy-container #mapsy-search-input')) cancel();
  }, true);
  document.addEventListener('focusout', event => {
    if (event.target === intent?.input) cancel();
  }, true);
  document.addEventListener('click', event => {
    if (intent && event.target !== intent.input) cancel();
  }, true);
})();
